import React from "react"
import { FormattedMessage } from "react-intl"

export default function LoaderGif({ id, loaderRef }) {
  return (
    <div
      id={id}
      className={"loaderGif dashed-black-border"}
      ref={loaderRef}
      style={{ height: "100px", alignItems: "center" }}
    >
      <div
        className="spinner-border text-primary text-center"
        role="status"
        style={{ marginBottom: "10px" }}
      />
      &nbsp;&nbsp;
      <h5>
        <FormattedMessage id={"general.loading"} description={`Loading...`} />
        ...
      </h5>
    </div>
  )
}
